import { Checkbox, CheckboxProps } from '@mantine/core'

interface TextMessageConsentCheckboxProps extends Omit<CheckboxProps, 'label'> {
  companyName?: string
  companyId?: string
}

const TextMessageConsentCheckbox = ({
  companyName,
  companyId,
  ...props
}: TextMessageConsentCheckboxProps) => {
  const consentTextPrefix = companyName
    ? `I agree to receive informational text messages from ${companyName} regarding my job application status, reminders, and updates.`
    : `I agree to receive informational text messages regarding my job application status, reminders, and updates.`

  const consentText = (
    <>
      {consentTextPrefix} Message frequency may vary. Message and data rates may
      apply. Reply <strong>STOP</strong> to opt out, <strong>HELP</strong> for
      help. Consent is not a condition of applying.
    </>
  )

  const termsUrl = companyId
    ? `${window.location.origin}/terms/${companyId}`
    : null

  const privacyPolicyUrl = companyId
    ? `${window.location.origin}/privacy/${companyId}`
    : null

  const label =
    termsUrl && privacyPolicyUrl ? (
      <span>
        {consentText}{' '}
        <a
          href={termsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-doubleNickel-brand-500 hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          Terms & Conditions
        </a>
        {' | '}
        <a
          href={privacyPolicyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-doubleNickel-brand-500 hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          Privacy Policy
        </a>
      </span>
    ) : (
      consentText
    )

  return <Checkbox label={label} {...props} />
}

export default TextMessageConsentCheckbox
